export default "__VITE_ASSET__D03ddcMi__"